import { OrderInfo, PayType } from "@/services/order";
import EnterprisePay from "./EnterprisePay";

export interface PayModalProps {
  open: boolean;
  successText?: string;
  onSuccess: (payType: PayType) => void;

  onClose: () => void;
  orderInfo?: OrderInfo;
}

export default function PayModal(props: PayModalProps) {
  if (!props.orderInfo) return null;

  return <EnterprisePay {...(props as any)} />;
}
